import { useState } from "react";
import { EFFECTS, type Effect } from "./effects";
import { ChaosMode } from "./ChaosMode";

type Selection =
  | { type: "effect"; effect: Effect }
  | { type: "chaos" };

export function TestPage() {
  const [sel, setSel] = useState<Selection>({ type: "effect", effect: EFFECTS[0]! });

  return (
    <main className="app test-page">
      {sel.type === "chaos" ? (
        <ChaosMode key="chaos" />
      ) : (
        <sel.effect.Component key={sel.effect.id} />
      )}

      <header className="app-header">
        <div className="bow-mark" aria-hidden>🎀</div>
        <p className="tagline">effect playground</p>
        <p className="test-sub">tap one to preview ♡</p>
      </header>

      <section className="test-grid" role="list">
        {EFFECTS.map(e => {
          const isActive = sel.type === "effect" && sel.effect.id === e.id;
          return (
            <button
              key={e.id}
              type="button"
              role="listitem"
              className={`test-chip${isActive ? " is-active" : ""}`}
              onClick={() => setSel({ type: "effect", effect: e })}
            >
              <span className="test-chip-emoji" aria-hidden>{e.emoji}</span>
              <span className="test-chip-name">{e.name}</span>
            </button>
          );
        })}
        <button
          type="button"
          role="listitem"
          className={`test-chip test-chip-chaos${sel.type === "chaos" ? " is-active" : ""}`}
          onClick={() => setSel({ type: "chaos" })}
        >
          <span className="test-chip-emoji" aria-hidden>🎂</span>
          <span className="test-chip-name">birthday chaos</span>
        </button>
      </section>

      <footer className="app-footer test-footer">
        <a className="test-back" href="/">← back to countdown</a>
        <span className="effect-badge">
          <span className="effect-badge-dot" />
          <span className="effect-badge-name">
            {sel.type === "chaos"
              ? "now showing: 🎂 birthday chaos"
              : `now showing: ${sel.effect.emoji} ${sel.effect.name}`}
          </span>
        </span>
      </footer>
    </main>
  );
}
